import { render, staticRenderFns } from "./grupoVeiculosAcessorios.vue?vue&type=template&id=9c8160c2"
import script from "./grupoVeiculosAcessorios.vue?vue&type=script&lang=js"
export * from "./grupoVeiculosAcessorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports